<span [hisDdKey]="dDKey" #dDValue></span>
<p-panel header="{{'fs.res.publication.GlobalIdentifier' | hisUi}}">

	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>

	<div *ngIf="!globalIdentifiers?.length">
		<div [ngClass]="dDValue.required ? 'requireMessage' : 'infoMessage'" [innerHTML]="'fs.res.publication.GlobalIdentifier.noIdentifierAssigned' | hisUi"></div>
	</div>
	<button (click)="addIdentifier()" hisImage="plus_circ_green" class="transparent"><span>{{'fs.res.publication.GlobalIdentifier.addIdentifier' | hisUi}}</span></button>

	<div *ngIf="globalIdentifiers?.length > 0">
		<p-table [value]="globalIdentifiers">
		    <ng-template pTemplate="header" let-columns>
		        <tr>
		            <th [pSortableColumn]="'globalIdentifierType.text'">{{'fs.res.publication.GlobalIdentifier.globalIdentifierType' | hisUi}}
		            	<p-sortIcon *ngIf="globalIdentifiers.length > 1" [field]="'globalIdentifierType.text'"></p-sortIcon>
		            </th>
		            <th>{{'fs.res.publication.GlobalIdentifier.identifier' | hisUi}}</th>
		            <th>{{'common.actions' | hisUi}}</th>
		        </tr>
		    </ng-template>
		    <ng-template pTemplate="body" let-globalIdentifier let-index="rowIndex" let-columns="columns">
		        <tr>
		            <td>{{globalIdentifier.globalIdentifierType?.defaulttext}}</td>
		            <td>{{globalIdentifier.identifier}}</td>
		            <td class="singleLine">
		            	<button (click)="editIdentifier(globalIdentifier, index)" hisImage="PENCIL" class="icon"
                            title="{{'common.editOf'|hisUi:(globalIdentifier.globalIdentifierType?.defaulttext+' '+globalIdentifier.identifier)}}">
                        </button>
		            	<button (click)="deleteIdentifier(index)" hisImage="DELETE" class="icon"
                            title="{{'common.deleteOf'|hisUi:(globalIdentifier.globalIdentifierType?.defaulttext+' '+globalIdentifier.identifier)}}">
                        </button>
		            </td>
		        </tr>
		    </ng-template>
		</p-table>
	</div>

    <ng-container *ngTemplateOutlet="customContentTemplate"></ng-container>
    
	<!-- #anchor dynamic field container -->
	<ng-template #dynamicFieldContainer></ng-template>
</p-panel>

<!-- create new external organisation in popup -->
<res-identifier-dialog *ngIf="identifierVisibility" [(visibility)]="identifierVisibility" [context]="context"
    [globalIdentifierHiskeyId]="dDKey"
    [globalIdentifier]="globalIdentifier"
    (globalIdentifierChange)="globalIdentifierChange($event)">
</res-identifier-dialog>
